import { render, staticRenderFns } from "./manufacturer.vue?vue&type=template&id=8607003a&scoped=true&"
import script from "./manufacturer.vue?vue&type=script&lang=js&"
export * from "./manufacturer.vue?vue&type=script&lang=js&"
import style0 from "./manufacturer.vue?vue&type=style&index=0&id=8607003a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8607003a",
  null
  
)

export default component.exports